import { render, staticRenderFns } from "./UpdateCheckBoardStatusDialog.vue?vue&type=template&id=0daf346c&scoped=true"
import script from "./UpdateCheckBoardStatusDialog.vue?vue&type=script&lang=js"
export * from "./UpdateCheckBoardStatusDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateCheckBoardStatusDialog.vue?vue&type=style&index=0&id=0daf346c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daf346c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0daf346c')) {
      api.createRecord('0daf346c', component.options)
    } else {
      api.reload('0daf346c', component.options)
    }
    module.hot.accept("./UpdateCheckBoardStatusDialog.vue?vue&type=template&id=0daf346c&scoped=true", function () {
      api.rerender('0daf346c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/UpdateCheckBoardStatusDialog.vue"
export default component.exports